var PeopleMedia = PeopleMedia || {};
PeopleMedia.CP = PeopleMedia.CP || {};
PeopleMedia.CP.Destination = (function($jq) {
    "use strict";

    var Oid = "PeopleMedia.CP.Destination";

    var _DestinationUrlOptions = [
        { name: 'Default', value: "" },
        { name: 'Upgrade', value: 'u' },
        { name: 'Home', value: 'homepage' },
        { name: 'Photo', value: 'photo' },
        { name: 'Notifcation', value: 'notification' },
        { name: 'Account', value: 'account' },
        { name: 'EditAlerts', value: 'editalerts' },
        { name: 'AccountPreferences', value: 'accountpreferences' },
        { name: 'AccountHistory', value: 'accounthistory' },
        { name: 'EditMyMatch', value: 'ditmymatch' },
        { name: 'QuickSearch', value: 'quicksearch' },
        { name: 'WhoLikesMyPhoto', value: 'wholikesmyphoto' },
        { name: 'PhotosILike', value: 'photosilike' },
        { name: 'FinishPhotoUpload', value: 'finishphotoupload' },
        { name: 'FinishSignUpQuestions', value: 'finishsignupquestions' },
        { name: 'MRC', value: 'mrc' },
        { name: 'ContactCare', value: 'contact' },
        { name: 'Help', value: 'help' },
        { name: 'EditProfile', value: 'editprofile' },
        { name: 'EditGreeting', value: 'editgreeting' },
        { name: 'WhoISaidYesTo', value: 'whoisaidyesto' },
        { name: 'WhoSaidYesToMe', value: 'whosaidyestome' },
        { name: 'TodaysMatches', value: 'todaysmatches' },
        { name: 'WhoViewedMe', value: 'whoviewedme' },
        { name: 'WhoBookmarkedMe', value: 'whobookmarkedme' },
        { name: 'WhoFlirtedWithMe', value: 'whoflirtedwithme' },
        { name: 'Search', value: 'search' },
        { name: 'ImInterested', value: 'iminterested' },
        { name: 'UsernameSearch', value: 'usernamesearch' },
        { name: 'MyMatch', value: 'mymatch' },
        { name: 'Keyword', value: 'keyword' },
        { name: 'WhosOnline', value: 'whosonline' },
        { name: 'WhosOnlineMarketing', value: 'whosonlinemarketing' },
        { name: 'BirthdaySearch', value: 'birthdaysearch' },
        { name: 'MyFlirts', value: 'myflirts' },
        { name: 'MyBookmarks', value: 'mybookmarks' },
        { name: 'MyViews', value: 'myviews' },
        { name: 'SuccessStories', value: 'sucessstories' },
        { name: 'DatingTips', value: 'datingtips' },
        { name: 'Inbox', value: 'inbox' },
        { name: 'PersonalityTestResult', value: 'ptr' },
        { name: 'Events', value: 'events' }
    ];

    var GetQuickSearchOfpParameters = function(options) {
        try {
            if (typeof options !== 'object' || options === null || options.length === 0) {
                options = {};
            }
            var seekingGender = options.seeking || $jq.queryString.get("seeking") || options.defaultSeeking || '';
            var zipcode = options.zipCode ||
                unescape($jq.queryString.get("zipcode") || '') ||
                options.defaultZipcode ||
                '';
            var minage = options.minage || $jq.queryString.get("minage") || options.defaultMinage || '';
            var maxage = options.maxage || $jq.queryString.get("maxage") || options.defaultMaxage || '';
            return 'gender=' +
                encodeURIComponent(seekingGender) +
                '|minage=' +
                encodeURIComponent(minage) +
                '|maxage=' +
                encodeURIComponent(maxage) +
                '|zipcode=' +
                encodeURIComponent(zipcode) +
                '|photo=1';
        } catch (ex) {
            return '';
        }
    };

    var getOfp = function (dest) {
        var keyLower = (dest || "").toLowerCase();
        var test = _DestinationUrlOptions.filter(function (item) { return item && item.name && item.name.toLowerCase() === keyLower; });
        if (test && test.length > 0) {
            return test[0].value;
        }
        return "";
    };

    var SetButtonDestination = function(setButtonName, setButtonDestination, options) {
        var destOfp = getOfp(setButtonDestination);
        var setButton = $jq("#" + setButtonName);

        if (!setButton.length) {
            setButton === $jq("." + setButtonName);
        }

        if (setButton.length) {
            setButton.on('click', function () {
                var flowOptions = $jq.extend({}, options, { ofp: destOfp });
                PeopleMedia.CP.startLoginFlow(flowOptions);
            });
        } else {
            try {
                console.log("No button found '" + setButtonName + "' please check your classname!");
            } catch (ex) {
            }
        }
    };

    return {
        GetQuickSearchOfpParameters: GetQuickSearchOfpParameters,
        SetButtonDestination: SetButtonDestination
    };

})(jQuery);

// for backwards compatibility only
PeopleMedia.CP.DestinationManager = function () {
};

// for backwards compatibility only
PeopleMedia.CP.DestinationManager.prototype = {
    GetQuickSearchOfpParameters: PeopleMedia.CP.Destination.GetQuickSearchOfpParameters,
    SetButtonDestination: PeopleMedia.CP.Destination.SetButtonDestination
};
